import { fetchEndpoint } from '../server/network'

// 获取购物车商品列表
export const cartGet = () => fetchEndpoint('/v2/ecapi.cart.get', 'POST', {})

// 修改购物车商品数量
export const cartUpdate = (data) => fetchEndpoint('/v2/ecapi.cart.update', 'POST', data)

// 获取购物车商品数量   温超二期  2016-8-23
export const cartQuantity = () =>fetchEndpoint('/v2/ecapi.cart.quantity', 'POST')

// 添加商品到购物车
export const cartAdd = (data) => fetchEndpoint('/v2/ecapi.cart.add', 'POST', data)

// 从购物车删除删除
export const cartDelete = (data) => fetchEndpoint('/v2/ecapi.cart.delete', 'POST', data)

// 购物车结算
export const cartCheckout = (data) => fetchEndpoint('/v2/ecapi.cart.checkout', 'POST', data)


// WEBPACK FOOTER //
// ./src/api/cart.js